import React from "react";

import { Input } from "~/components/ui/input";

interface AmountInputProps {
  value: number | undefined;
  onChange: (value: number) => void;
  placeholder?: string;
  className?: string;
}

const AmountInput: React.FC<AmountInputProps> = ({
  value,
  onChange,
  placeholder = "0.00",
  className,
}) => {
  return (
    <Input
      type="number"
      placeholder={placeholder}
      value={value === undefined ? "" : value}
      onChange={(e) => {
        const value = e.target.value ? parseFloat(e.target.value) : undefined;
        onChange(value as number);
      }}
      className={className}
    />
  );
};

export default AmountInput;
